import styled from 'styled-components'
import { BigCard, Block, Flex, Title, TotalNumber } from '../StatisticsPage'
import { useTranslation } from '../../../../../hooks'

const Info = styled.p`
    font-size: 1.8rem;
    margin: 0 0 0 0.5rem;
    padding: 2rem 0;
`

const CenterContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
    margin-bottom: 4rem;
`

interface AveragesData {
    toClose: number | null
    toRespond: number | null
}

interface ActionStatsProps {
    averages: AveragesData
}

const ActionStats = ({ averages }: ActionStatsProps) => {
    const translation = useTranslation()

    const formatDuration = (days: number) => {
        const totalMinutes = days * 24 * 60

        if (totalMinutes < 60) {
            const minutes = Math.max(1, Math.round(totalMinutes))
            return `${minutes} ${
                minutes === 1
                    ? translation.trialWarning.minute
                    : translation.trialWarning.minutes
            }`
        }

        const totalHours = days * 24
        if (totalHours < 24) {
            const hours = Math.round(totalHours * 10) / 10
            return `${hours} ${
                hours === 1
                    ? translation.trialWarning.hour
                    : translation.trialWarning.hours
            }`
        }

        const roundedDays = Math.round(days * 10) / 10
        return `${roundedDays} ${
            roundedDays === 1
                ? translation.trialWarning.day
                : translation.trialWarning.days
        }`
    }

    const toRespondText = () => {
        if (averages.toRespond === null) {
            return translation.statisticsPage.noData
        }

        return formatDuration(averages.toRespond)
    }

    const toCloseText = () => {
        if (averages.toClose === null) {
            return translation.statisticsPage.noData
        }

        return `${averages.toClose} ${
            averages.toClose === 1
                ? translation.trialWarning.day
                : translation.trialWarning.days
        } `
    }

    return (
        <BigCard>
            <Title>{translation.statisticsPage.actionStats}</Title>
            <CenterContainer>
                <Block>
                    <Info>
                        {translation.statisticsPage.avgDaysToFirstResponse}
                    </Info>
                    <Flex alignItems="baseline" justifyContent="normal">
                        <TotalNumber>{toRespondText()}</TotalNumber>
                        {/* <UpOrDown color="red">
                            <ArrowUp color="red" />
                            11% {translation.statisticsPage.lastYear}
                        </UpOrDown> */}
                    </Flex>
                </Block>
                <Block>
                    <Info>
                        {translation.statisticsPage.avgDaysToClosedCase}
                    </Info>
                    <Flex alignItems="baseline" justifyContent="normal">
                        <TotalNumber>{toCloseText()}</TotalNumber>
                        {/* <UpOrDown color="green">
                            <ArrowDown color="green" />
                            31% {translation.statisticsPage.lastYear}
                        </UpOrDown> */}
                    </Flex>
                </Block>
            </CenterContainer>
        </BigCard>
    )
}

export default ActionStats
